"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const invariant_1 = __importDefault(require("invariant"));
const jsHelpers_1 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const api_1 = require("./api");
const logic_1 = require("./logic");
const prepareTransaction = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    const networkInfo = t.networkInfo || (yield (0, api_1.fetchAccountNetworkInfo)(a));
    (0, invariant_1.default)(networkInfo.family === "stellar", "stellar networkInfo expected");
    const fees = t.fees || networkInfo.fees;
    const baseReserve = t.baseReserve || networkInfo.baseReserve;
    const [assetCode, assetIssuer] = (0, logic_1.getAssetCodeIssuer)(t);
    if (t.networkInfo !== networkInfo || t.fees !== fees || t.baseReserve !== baseReserve) {
        return (0, jsHelpers_1.defaultUpdateTransaction)(t, { networkInfo, fees, baseReserve, assetCode, assetIssuer });
    }
    return (0, jsHelpers_1.defaultUpdateTransaction)(t, { assetCode, assetIssuer });
});
exports.default = prepareTransaction;
//# sourceMappingURL=js-prepareTransaction.js.map